import gql from 'graphql-tag';

export const GET_UTILITY_CONNECT_CTA_QUERY = gql`
  query GetUtilityConnectCtaInfo($planId: Int!) {
    plan(id: $planId) {
      id
      cleanKilowattHours {
        id
        kwh
      }
      utilityAccounts {
        id
        utility {
          id
          displayName
        }
      }
      utilityCredentials {
        id
        verificationStatus
      }
    }
  }
`;

export const getUtilityConnectCtaMock = {
  plan: {
    cleanKilowattHours: [
      {
        id: 5,
        kwh: 100,
        productSubscription: {
          id: 9,
          product: {
            id: 10,
            key: 'usage_based',
          },
        },
      },
    ],
    id: 1,
    utilityAccounts: [
      {
        id: 5,
        utility: {
          displayName: 'Dominion',
          id: 3,
        },
      },
    ],
    utilityCredentials: [
      {
        id: 5,
        verificationStatus: 'empty',
      },
    ],
  },
};
